import { render, staticRenderFns } from "./datalogger.vue?vue&type=template&id=28ae441f&scoped=true&"
import script from "./datalogger.vue?vue&type=script&lang=js&"
export * from "./datalogger.vue?vue&type=script&lang=js&"
import style0 from "./datalogger.vue?vue&type=style&index=0&id=28ae441f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae441f",
  null
  
)

export default component.exports